import { image_host } from "config/api_host";
import { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromCart, updateQuantity, clearCart } from "store/reducers/cartReducer";
import { useAvailableBanks } from "api/Client/balance";
import { useCreateOrder } from "api/Client/product";
import { createAlert } from "components/Alert/Alert";
import {
  FaCreditCard,
  FaTrashAlt,
  FaRegImage,
  FaShoppingCart,
  FaPlus,
  FaMinus,
} from "react-icons/fa";
import { Spinner } from "components";
import { Link } from "react-router-dom";

export default function MyCart() {
  const dispatch = useDispatch();
  const myProducts = useSelector((state) => state.myCart.myProducts);
  const { role } = useSelector((state) => state.auth);

  useEffect(() => {
    console.log(myProducts);
  }, [myProducts]);

  const [image, setImage] = useState(null);
  const [amount, setAmount] = useState(0);
  const [selectedBank, setSelectedBank] = useState("");

  const { mutate: create, isPending: IsPending } = useCreateOrder();
  const { data: banks } = useAvailableBanks(role == "guest" ? false : true);

  // حساب الإجمالي الكلي للسلة بناءً على السعر والكمية لكل منتج
  const totalCartPrice = useMemo(() => {
    return myProducts.reduce(
      (acc, item) => acc + Number(item.price) * (item.quantity || 1),
      0,
    );
  }, [myProducts]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!image) return createAlert("Warning", "يرجى ادخال صورة الاشعار");
    if (!selectedBank) return createAlert("Warning", "يرجى اختيار طريقة الدفع");

    const formData = new FormData();

    // إرسال المصفوفة كما يتوقعها الـ Back-end
    myProducts.forEach((product, key) => {
      formData.append(`items[${key}][product_id]`, product.id);
      formData.append(`items[${key}][qty]`, product.quantity || 1);
    });

    formData.append("payment_receipt", image);
    formData.append("paid_amount", amount);
    formData.append("bank_id", selectedBank);

    create(formData, {
      onSuccess: () => dispatch(clearCart()),
    });
  };

  return (
    <div
      className="p-4 md:p-8_ max-w-6xl w-full mx-auto font-[Tajawal] space-y-8"
      dir="rtl"
    >
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="p-3 bg-mainLight/10 rounded-2xl text-mainLight shadow-inner">
          <FaShoppingCart size={24} />
        </div>
        <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
          سلة المشتريات
        </h2>
      </div>

      {myProducts.length > 0 ? (
        <div className="grid grid-cols-1 gap-8">
          {/* قائمة المنتجات */}
          <div className="space-y-4">
            {myProducts.map((item) => (
              <CartItem key={item.id} product={item} />
            ))}
          </div>

          {/* حاوية الدفع الزجاجية (Minimalist Glassmorphism) */}
          <div className="bg-gray-100 dark:bg-white/5 border border-white dark:border-white/10 rounded-[2.5rem] shadow-2xl overflow-hidden backdrop-blur-xl">
            <div className="p-8 space-y-8">
              <h5 className="flex items-center gap-2 text-lg font-bold text-gray-700 dark:text-gray-200">
                <FaCreditCard className="text-mainLight" /> تفاصيل الدفع
                والتحويل
              </h5>

              {role == "guest" ? (
                <div
                  className="py-24 text-center bg-gray-100 dark:bg-white/5 
                rounded-[3rem] border-2 border-dashed 
                border-gray-200 dark:border-white/10"
                >
                  <div className="text-6xl mb-6">🔐</div>

                  <h3 className="text-xl font-bold text-gray-600 dark:text-gray-300">
                    يجب تسجيل الدخول
                  </h3>

                  <p className="text-sm text-gray-500 mt-2 leading-relaxed">
                    يرجى تسجيل الدخول أو إنشاء حساب جديد لتتمكن من إتمام عملية
                    الدفع والاطلاع على وسائل الدفع المتاحة.
                  </p>

                  <Link
                    to="/login"
                    className="inline-flex items-center justify-center mt-6
               px-6 py-3 rounded-xl font-bold
               bg-mainLight text-white
               hover:bg-mainLight/90
               transition-all shadow-lg
               hover:-translate-y-1 active:scale-95"
                  >
                    تسجيل الدخول
                  </Link>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {/* معلومات البنك */}
                  <div className="space-y-4">
                    <div className="space-y-2">
                      <label className="text-[11px] font-bold text-gray-400 mr-2 uppercase tracking-wider">
                        وسيلة الدفع
                      </label>
                      <select
                        value={selectedBank}
                        onChange={(e) => setSelectedBank(e.target.value)}
                        className="w-full h-14 px-4 rounded-2xl bg-white dark:bg-white/5 border-2 border-gray-200 dark:border-white/10 text-gray-700 dark:text-white font-bold outline-none focus:border-mainLight transition-all appearance-none cursor-pointer shadow-sm"
                      >
                        <option value="" disabled>
                          اختر البنك أو المحفظة...
                        </option>
                        {banks?.data?.map((bank) => (
                          <option
                            key={bank.bank_id}
                            value={bank.bank_id}
                            className="text-black"
                          >
                            {bank.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {selectedBank && (
                      <div className="p-5 rounded-2xl bg-mainLight/5 border border-dashed border-mainLight/30 animate-in fade-in slide-in-from-top-2">
                        <div
                          className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed font-medium"
                          dangerouslySetInnerHTML={{
                            __html: banks?.data
                              .find((item) => item.bank_id == selectedBank)
                              ?.description?.replace(/\n/g, "<br />"),
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {/* النموذج */}

                  <form onSubmit={onSubmit} className="space-y-5">
                    <div className="space-y-2">
                      <label className="text-[11px] font-bold text-gray-400 mr-2 uppercase tracking-wider">
                        المبلغ المرسل
                      </label>
                      <input
                        type="number"
                        placeholder="0.00"
                        className="w-full h-14 px-6 rounded-2xl bg-white dark:bg-white/10 border border-gray-200 dark:border-white/10 text-gray-800 dark:text-white font-bold outline-none focus:ring-4 focus:ring-mainLight/10 focus:border-mainLight transition-all"
                        onChange={(e) => setAmount(e.target.value)}
                        required
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="text-[11px] font-bold text-gray-400 mr-2 uppercase tracking-wider">
                        إرفاق صور الإشعار
                      </label>
                      <div className="relative h-14 group">
                        <input
                          type="file"
                          accept="image/*"
                          className="absolute inset-0 w-full h-full opacity-0 z-10 cursor-pointer"
                          onChange={(e) => setImage(e.target.files[0])}
                          required
                        />
                        <div className="w-full h-full flex items-center justify-between px-6 rounded-2xl bg-white dark:bg-white/10 border border-dashed border-gray-300 dark:border-white/20 text-gray-400 group-hover:border-mainLight transition-colors">
                          <span className="text-xs font-bold truncate">
                            {image ? image.name : "اضغط لرفع الصورة"}
                          </span>
                          <FaRegImage className="text-mainLight" />
                        </div>
                      </div>
                    </div>

                    <div className="pt-6 flex flex-col items-center gap-4">
                      <div className="text-center">
                        <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">
                          المبلغ الإجمالي المطلوب
                        </p>
                        <p className="text-4xl font-bold text-gray-800 dark:text-white">
                          <span className="text-mainLight">$</span>
                          {totalCartPrice.toLocaleString()}
                        </p>
                      </div>

                      <button
                        disabled={IsPending}
                        className="w-full h-14 bg-mainLight text-white font-bold rounded-2xl shadow-xl shadow-mainLight/20 hover:shadow-mainLight/40 hover:-translate-y-1 transition-all active:scale-95 disabled:opacity-50 flex items-center justify-center gap-2"
                      >
                        {IsPending ? <Spinner sm /> : "إرسال طلب الحجز"}
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="py-24 text-center bg-gray-100 dark:bg-white/5 rounded-[3rem] border-2 border-dashed border-gray-200 dark:border-white/10">
          <div className="text-6xl mb-6 grayscale opacity-50">🛒</div>
          <h3 className="text-xl font-bold text-gray-400">
            سلة المشتريات فارغة
          </h3>
          <p className="text-sm text-gray-500 mt-2">
            لم تقم بإضافة أي منتج بعد!
          </p>
        </div>
      )}
    </div>
  );
}

const CartItem = ({ product }) => {
  const dispatch = useDispatch();

  // ملاحظة: قمت باستخدام product.quantity المأخوذ من البيانات التي أرسلتها
  // إذا أردت تفعيل أزرار الـ + والـ -، يجب إضافة Action في الـ Slice باسم updateQuantity
  const qty = Number(product.quantity);

  return (
    <div className="group relative flex flex-col md:flex-row items-center gap-6 p-5 bg-white/90 dark:bg-white/5 border border-white dark:border-white/10 rounded-[2rem] shadow-lg hover:shadow-2xl transition-all duration-300">
      {/* زر الحذف */}
      <button
        onClick={() => dispatch(removeFromCart(product.id))}
        className="absolute top-2 left-2 p-1.5 bg-red-50 dark:bg-red-500/10 text-red-500 rounded-xl opacity-0 group-hover:opacity-100 transition-all hover:bg-red-500 hover:text-white"
      >
        <FaTrashAlt size={14} />
      </button>

      {/* الصورة */}
      <div className="w-32 md:w-36 flex-shrink-0">
        <img
          src={image_host + product.image}
          alt={product.name}
          className="w-full h-auto drop-shadow-xl group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      {/* التفاصيل */}
      <div className="flex-1 text-center md:text-right space-y-2">
        <div>
          <span className="text-[10px] font-bold text-mainLight uppercase tracking-tighter">
            {product.company_name}
          </span>
          <h3 className="text-xl font-bold text-gray-800 dark:text-white leading-none">
            {product.name}
          </h3>
        </div>

        <div className="flex flex-wrap justify-center md:justify-start gap-2">
          {product.fields &&
            JSON.parse(product.fields)
              .slice(0, 3)
              .map((f) => (
                <div
                  key={f.fieldId}
                  className="px-2 py-1 bg-gray-50 dark:bg-white/5 rounded-lg border border-gray-100 dark:border-white/5 text-[10px] text-gray-500 dark:text-gray-400"
                >
                  <span className="font-bold text-gray-700 dark:text-gray-200">
                    {f.name}:
                  </span>{" "}
                  {f.value}
                </div>
              ))}
        </div>
      </div>

      {/* السعر والكمية */}
      <div className="flex md:flex-col items-center md:items-end justify-between w-full md:w-auto gap-4 px-4 md:px-0">
        <div className="text-2xl font-bold text-gray-800 dark:text-white">
          <span className="text-mainLight text-sm">$</span>
          {(Number(product.price) * qty).toLocaleString()}
        </div>

        <div className="flex items-center bg-gray-50 dark:bg-black/20 rounded-xl p-1 border border-gray-200 dark:border-white/5">
          <button
            onClick={(e) =>
              dispatch(
                updateQuantity({
                  id: product.id,
                  quantity: qty - 1,
                }),
              )
            }
            className="p-2 text-gray-400 hover:text-mainLight transition"
          >
            <FaMinus size={10} />
          </button>
          <span className="px-3 font-bold text-sm text-gray-700 dark:text-white">
            {qty}
          </span>
          <button
            onClick={(e) =>
              dispatch(
                updateQuantity({
                  id: product.id,
                  quantity: qty + 1,
                }),
              )
            }
            className="p-2 text-gray-400 hover:text-mainLight transition"
          >
            <FaPlus size={10} />
          </button>
        </div>
      </div>
    </div>
  );
};
